import customAxios from "./axiosConfig";

const CompanySettingService = {
  update: function (data) {
    const config = {
      headers: { 'content-type': 'application/json;charset=UTF-8' },
    };
    return customAxios.put(window.Urls["company_settings_detail"](data.id), data, config);
  },
  retrieve(params) {
    const api_url = '/api/v2/company-settings/'
    return customAxios.get(api_url, { params: params });
  },
  list(params) {
    const api_url = window.Urls['company_settings_list']();
    return customAxios.get(api_url, { params: params });
  },
  partialUpdate(id, data) {
    const api_url = window.Urls['company_settings_detail'](id);
    return customAxios.patch(api_url, data);
  },
  uploadDigitalCertificate(id, data) {
    const config = {
      headers: { 'content-type': 'multipart/form-data' },
    }

    const getFormData = object => Object.keys(object).reduce((formData, key) => {
        if(Array.isArray(object[key])) {
            formData.append(key, JSON.stringify(object[key]))
        } else {
            formData.append(key, object[key])
        }
        return formData
    }, new FormData())

    const api_url = window.Urls["company_settings_upload_digital_certificate"](id)
    return customAxios.post(api_url, getFormData(data), config)
  },
  deleteCertificate(id) {
    const api_url = window.Urls['company_settings_delete_digital_certificate'](id)
    return customAxios.delete(api_url)
  }
};

export default CompanySettingService;